import { render, staticRenderFns } from "./FormDocumentTemplate.vue?vue&type=template&id=8238138c"
import script from "./FormDocumentTemplate.vue?vue&type=script&lang=js"
export * from "./FormDocumentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormDocumentTemplate.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8238138c')) {
      api.createRecord('8238138c', component.options)
    } else {
      api.reload('8238138c', component.options)
    }
    module.hot.accept("./FormDocumentTemplate.vue?vue&type=template&id=8238138c", function () {
      api.rerender('8238138c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/FormDocumentTemplate.vue"
export default component.exports